import { SecondaryText, SingleCardItem, SubTitle, Title } from "components/views/ui";

const CARHACK2026 = () => {
    return (
        <SingleCardItem>
            <Title
                title={
                    "CTF @ Car Hacking Training 2026 by Willem Melching, I CAN Hack"
                }
                hyperLink="https://icanhack.nl/training/"
            />
            <SubTitle title={"05/2026"} />
            <SecondaryText text={"1st Place"} />
        </SingleCardItem>
    );
};

export default CARHACK2026;
